import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { useParams } from "react-router-dom-v5-compat";
export const SingleSignOn = () => {
    const { sku } = useParams();
    return (_jsxs(_Fragment, { children: [!sku && _jsx(Typography, Object.assign({ align: "center" }, { children: "Single Sign On!" })), sku && _jsxs(Typography, Object.assign({ align: "center" }, { children: ["Single Sign On for Sku: ", sku] }))] }));
};
